'use strict';

import _ from 'lodash';

import React, { Component } from 'react';
import LegacyPaypalButton from '../payments/LegacyPaypalButton';
import LegacyPaypalButtonLang from '../payments/LegacyPaypalButtonLang';

/**
 * Renders a PayPal button for submitting payment information to
 * Braintree. This React component wraps a non-React, legacy PayPal
 * button component.
 */
export default class PaypalButton extends Component {
	constructor(props) {
		super(props);

		this.state = {
			paypalButton: null
		};
	}

	componentDidMount() {
		this.createPaypalButton(this.props);
	}

	componentWillReceiveProps(nextProps) {
		this.state.paypalButton && this.state.paypalButton.refresh(nextProps);
	}

	componentWillUnmount() {
		this.state.paypalButton && this.state.paypalButton.cleanup();
	}

	getDeviceData() {
		return _.get(this.state, ['paypalButton', 'braintreeInstance', 'deviceData']);
	}

	// Creates the legacy PayPal button component and adds it beneath this component's
	// div.
	createPaypalButton(props) {
		const paypalButton = new LegacyPaypalButton(props, {
			customBillingMessage: props.isUpdateDetails
				? LegacyPaypalButtonLang.BILLING_DETAILS_UPDATED
				: null,
			setup: {
				onPaymentMethodReceived: braintreeResponse => {
					this.props.handleSubmit({
						braintreeResponse,
						braintreeDeviceData: this.getDeviceData()
					});
					paypalButton.refresh();
				},
				onError: error => {
					this.props.handleError && this.props.handleError(error);
					paypalButton.refresh();
				}
			}
		});

		if (paypalButton.dom[0]) {
			this.el.appendChild(paypalButton.dom[0]);
		}

		this.setState({
			paypalButton: paypalButton
		});
	}

	render() {
		// Use an empty div so that React has no reason to re-render it. The
		// legacy PayPal component can then freely manipulate the DOM beneath
		// without concern for React.
		return <div ref={el => (this.el = el)} />;
	}
}
